// Generic empty-state block — icon + explanatory text + optional CTA.
// Used anywhere a section has no data yet (budgets, transactions, etc.)
// instead of a plain gray "no hay datos" line.
export default function EmptyState({ icon: Icon, title, description, ctaLabel, onCtaClick, testId }) {
  return (
    <div className="flex flex-col items-center text-center py-8 px-4" data-testid={testId}>
      <div className="w-11 h-11 rounded-2xl bg-violet-500/10 flex items-center justify-center mb-3">
        <Icon className="w-5 h-5 text-violet-400" />
      </div>
      <p className="text-sm font-medium text-slate-300">{title}</p>
      {description && (
        <p className="text-xs text-slate-400 mt-1 max-w-xs">{description}</p>
      )}
      {ctaLabel && onCtaClick && (
        <button
          type="button"
          onClick={onCtaClick}
          className="mt-4 text-xs font-semibold text-violet-400 hover:text-violet-300 transition-colors"
        >
          {ctaLabel} →
        </button>
      )}
    </div>
  );
}
